import {
    changeSalePriceSet,
    clearSale,
    setLiveProfit,
    updateCurrentSale,
} from "../../Actions/SellScreen/SellScreenActions.tsx";
import { compare } from "../../Utilities/Generic/Objects";
import { subscribeToOption } from "../../Utilities/Platform/Options/Options";
import { Application } from "../Application";
import { Bootstrapper } from "../Bootstrapper";
import type { ShopfrontDispatch } from "../hooks";

export class SaleBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): MaybePromise<void> {
        const store = Application.get("Redux");

        // Subscribe to the current sale
        // In the future we probably want to move this to just occur on the sell screen instead of being connected
        // through the entire POS
        subscribeToOption("current_sale", (_, newValue, oldValue) => {
            if(!newValue && !!oldValue) {
                // If we no longer have a sale in a different tab, we should clear it from the local state
                console.log("Removing the sale due to a change in a different tab");
                store.dispatch(clearSale(true));
            } else if(newValue !== null && !compare(oldValue, newValue)) {
                // If we've updated the sale in a different tab, we need to make sure this tab also has it sync'd
                console.log("Updating the sale due to a change in a different tab");
                store.dispatch(updateCurrentSale(newValue));
            }
        });

        // Subscribe to price set changes
        subscribeToOption("register_default_price_set", (option, newValue, oldValue) => {
            const state = store.getState();

            if(
                !state.sellscreen.sale.products.length &&
                !state.sellscreen.sale.customer &&
                oldValue !== newValue
            ) {
                store.dispatch(changeSalePriceSet(newValue as string));
            }
        });

        // Subscribe to live profit changes
        subscribeToOption("live_profit", (_, newValue, oldValue) => {
            if(newValue !== oldValue) {
                (store.dispatch as ShopfrontDispatch)(setLiveProfit(newValue as boolean));
            }
        });
    }
}
